import styled from "styled-components"

const Badge = styled.span<{ $variant: "high" | "medium" | "low" }>`
  display: inline-block;
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid;

  ${({ $variant }) => {
    switch ($variant) {
      case "high":
        return `
          color: var(--status-danger);
          border-color: #fca5a5;
          background-color: var(--status-danger-subtle);
        `
      case "medium":
        return `
          color: var(--status-warning);
          border-color: #fcd34d;
          background-color: var(--status-warning-subtle);
        `
      case "low":
        return `
          color: var(--status-success);
          border-color: #86efac;
          background-color: var(--status-success-subtle);
        `
    }
  }}
`

export type PriorityBadgeVariant = "high" | "medium" | "low"

interface Props {
  variant: PriorityBadgeVariant
  children: React.ReactNode
}

export const PriorityBadge = ({ variant, children }: Props) => <Badge $variant={variant}>{children}</Badge>
